export function parseSitecoreFloat(sitecoreFloat?: string) {
  return sitecoreFloat ? parseFloat(sitecoreFloat.toString().replace(',', '.')) : 0;
}
